import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Carrier from './component';

const carrier = {
  id: 'markAsShipped.columns.carrier',
  defaultMessage: 'Carrier',
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(carrier);
};

export default {
  id: 'mark-as-shipped-carrier',
  index: 3,
  isDragable: false,
  minWidth: 100,
  width: 150,
  nonsortable: true,
  getName: GetName,
  name: <FormattedMessage {...carrier} />,
  render: (data) => {
    return <Carrier fulfillmentPlanId={data.id} />;
  },
};
